import { render, staticRenderFns } from "./saleModal.vue?vue&type=template&id=65d59d68&scoped=true&"
import script from "./saleModal.vue?vue&type=script&lang=js&"
export * from "./saleModal.vue?vue&type=script&lang=js&"
import style0 from "./saleModal.vue?vue&type=style&index=0&id=65d59d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d59d68",
  null
  
)

export default component.exports